let lastScroll = 0;
const initHamburg = () => {
  const myOffcanvas = document.getElementById('mainMenuContainer')
  myOffcanvas.addEventListener('show.bs.offcanvas', event => {
    document.querySelector('.ku-hamburger-icon').classList.add('menu-show');
  });
  myOffcanvas.addEventListener('hide.bs.offcanvas', event => {
    document.querySelector('.ku-hamburger-icon').classList.remove('menu-show');
  });
};
export default initHamburg;
